export default __webpack_public_path__ + "static/media/plus-divider.86c77a67.svg";